import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/enterprise/enterprise.component').then(
        m => m.EnterpriseComponent,
      ),
  },
];
